import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
import { SkeletonBlock } from '../SkeletonBlock';
const Styles = labelStyles('SkeletonText', {
    root: (props) => [
        {
            display: 'grid',
            gridTemplateColumns: '100%',
            gap: 5,
        },
        withModifier(props.textAlign, {
            justifyItems: {
                left: 'start',
                right: 'end',
                center: 'center',
                justify: 'left',
            }[props.textAlign],
        }),
    ],
});
const getLineHeight = (props) => ({
    heading: 30,
    body: 15,
}[props.size]);
const getLineWidth = (props, idx) => {
    if (idx === 0 && props.lines === 1) {
        return '100%';
    }
    if (idx === props.lines - 1) {
        return '70%';
    }
    if (props.textAlign === 'justify') {
        return '100%';
    }
    return idx % 2 ? '100%' : '93%';
};
export const SkeletonText = (props) => {
    const blocks = Array.from({ length: props.lines }).map((_, idx) => {
        return (isolateComponent(SkeletonBlock, { height: getLineHeight(props), key: idx, width: getLineWidth(props, idx) }));
    });
    const style = {
        width: props.width,
    };
    return (isolateComponent("div", { css: Styles.root(props), "data-testid": "SkeletonText", style: style }, blocks));
};
SkeletonText.defaultProps = {
    size: 'body',
    textAlign: 'left',
    width: '100%',
};
//# sourceMappingURL=SkeletonText.js.map
// @zapier/design-system@5.32.5 (2004a9d50)
